import React, { useState, useRef } from 'react';
import { createStorefrontApiClient } from '@shopify/storefront-api-client';
import { Header } from './components/header';
import { MainContent } from './components/mainContent';
import { ShopifyProduct } from './components/shopifyProduct';
import { ShopifyCart } from './components/shopifyCart';
import { Modal } from './components/modal';
import { Footer } from './components/footer';
import './css/shopify.css';

const STORE_ENABLED = process.env.REACT_APP_FEATURE_STORE === 'true';

const CART_CREATE_MUTATION = `
  mutation cartCreate($lines: [CartLineInput!]) {
    cartCreate(input: { lines: $lines }) {
      cart {
        id
        checkoutUrl
        lines(first: 10) {
          edges {
            node {
              id
              quantity
              cost {
                totalAmount { amount currencyCode }
              }
              merchandise {
                ... on ProductVariant {
                  title
                  product {
                    title
                    images(first: 1) {
                      edges { node { url altText } }
                    }
                  }
                }
              }
            }
          }
        }
        cost {
          totalAmount { amount currencyCode }
        }
      }
    }
  }
`;

const CART_LINES_ADD_MUTATION = `
  mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        id
        checkoutUrl
        lines(first: 10) {
          edges {
            node {
              id
              quantity
              cost {
                totalAmount { amount currencyCode }
              }
              merchandise {
                ... on ProductVariant {
                  title
                  product {
                    title
                    images(first: 1) {
                      edges { node { url altText } }
                    }
                  }
                }
              }
            }
          }
        }
        cost {
          totalAmount { amount currencyCode }
        }
      }
    }
  }
`;

const shopifyClient = createStorefrontApiClient({
    storeDomain: '8e0b3d-2.myshopify.com',
    apiVersion: '2025-01',
    publicAccessToken: '478055379efc9373a7f07beee70b92c3',
});

export function App() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const modalContent = 'sizeGuide';

    const [cart, setCart] = useState(null);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const cartIdRef = useRef(null);

    const toggleModal = () => {
        setIsModalOpen((prevState) => !prevState);
    };

    const handleAddToCart = async (variantId) => {
        const lines = [{ merchandiseId: variantId, quantity: 1 }];
        try {
            if (!cartIdRef.current) {
                const { data } = await shopifyClient.request(CART_CREATE_MUTATION, {
                    variables: { lines },
                });
                const newCart = data.cartCreate.cart;
                cartIdRef.current = newCart.id;
                setCart(newCart);
            } else {
                const { data } = await shopifyClient.request(CART_LINES_ADD_MUTATION, {
                    variables: { cartId: cartIdRef.current, lines },
                });
                setCart(data.cartLinesAdd.cart);
            }
            setIsCartOpen(true);
        } catch (err) {
            console.error('Failed to update cart:', err);
        }
    };

    return (
        <div className='wrapper gradiant'>
            <Header />
            <MainContent />
            {STORE_ENABLED && (
                <>
                    <div className='product-grid'>
                        <ShopifyProduct shopifyClient={shopifyClient} onAddToCart={handleAddToCart} productId="8512091324690" />
                        <ShopifyProduct shopifyClient={shopifyClient} onAddToCart={handleAddToCart} productId="8512624656658" />
                    </div>
                    <ShopifyCart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} cart={cart} />
                </>
            )}
            {/* <Modal
                isOpen={isModalOpen}
                onClose={toggleModal}
                modalContent={modalContent}
            /> */}
            {/* <Footer onToggleModal={toggleModal} /> */}
        </div>
    );
}
